var map = {
	"./blackGold/footer/Icon-support.png": 65085,
	"./brownGold/footer/Icon-support.png": 72267,
	"./darkBlue/footer/Icon-support.png": 45840,
	"./greenYellow/footer/Icon-support.png": 13979,
	"./redGold/footer/Icon-support.png": 38909,
	"./skyBlue/footer/Icon-support.png": 58853,
	"./whiteGold/footer/Icon-support.png": 44208,
	"./yellowWhite/footer/Icon-support.png": 10593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20885;